module.exports = __webpack_public_path__ + "assets/4ffcf2a896500507c9d4f10f05e37649.mp3";